<template>
  <f7-page>
    <div class="menu">
      <PCSideNavbar />
    </div>
    <f7-row>
      <f7-col
        width="90"
        style="margin-left: 125px;"
      >
        <f7-row style="max-height: 70px; height: 70px;">
          <f7-col
            width="25"
            style="max-width: 250px; margin-top: 18px; border-right: 1px solid rgb(151 151 151 / 30%);"
          >
            <span v-if="logoApp">
              <img
                id="logo"
                alt="logoEmpresa"
                class="logo-empresa-frmTablet"
                :src="logoApp"
              >
            </span>
            <span v-else>
              <img
                id="logo"
                alt="logoEmpresa"
                class="logo-empresa-frmTablet"
                :src="LOGO_HISPATEC"
              >
            </span>
          </f7-col>
          <f7-col
            width="50"
            class="temp-padding-top"
          >
            <!-- <UCLineasDeProduccion
              :valor-por-defecto="lineaSeleccionadaAlIniciarFormulario"
              plantilla="P2"
              :mostrar-titulo="false"
              @lineaProduccionSeleccionada="LineaProduccionSeleccionada"
            /> -->
            <UCSearchEntityERP
              :placeholder="$t('common.productionLine')"
              :search-text="$t('searchEntity.line.searchText')"
              :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
              :default-value="lineaSeleccionadaAlIniciarFormulario"
              :default-etities-list="lineasProduccion"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :next-and-previous-buttons-shown="true"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :emit-evet-change-default-value="true"
              @selection="LineaProduccionSeleccionada"
            />
          </f7-col>
          <f7-col
            width="25"
            class="div-logoHispatecDerecha"
          >
            <img
              id="logo"
              alt="logoHispatec"
              class="img-logoHispatec"
              :src="LOGO_HISPATEC"
            >
          </f7-col>
        </f7-row>

        <f7-row class="row-cabeceraOpcionesFrm">
          <div
            class="div-indicadorNumeroTrabajadoresLineaProduccion"
            @click="IndicarNumeroTrabajadorLineaManual"
          >
            <img
              align="right"
              alt="iconTrabajador"
              src="@/static/icons/ic_workers_yellow_indicator.svg"
              class="seleccionable"
            >
            <span
              class="span-indicadorNumeroTrabajadores"
            > {{ numeroTrabajadoresLinea }}</span>
          </div>
          <span
            class="btn-oval-azulOscuro-26 btn-actualizarPlanificadosLinea seleccionable"
            @click="ActualizarPedidosPlanificadosLineaProduccion()"
          >A</span>
          <!----  Boton para cambiar de completos a pendientes -->
          <div
            class="div-btnCambioPedidosPendientesFinalizados seleccionable"
            @click="AbrirFormularioDePedidosCompletos()"
          >
            <span class=""> {{ $t('Completos') }}</span>
          </div>
        </f7-row>

        <f7-row style="margin-top: 30px;">
          <UCPreload
            :show="mostrarPrecarga"
            style="width: 100%;"
          />
          <f7-col
            v-if="!mostrarPrecarga"
            width="100"
          >
            <div
              v-for="pedido in listadoPedidosPlanificados"
              :key="pedido.IdLineaPedidoVenta"
              class="ElementoPedido"
              @click="LineaPedidoPlanificadoSeleccionado(pedido)"
            >
              <!-- <pre>{{pedido}}</pre> -->
              <f7-row style="margin-top: 30px;">
                <f7-col
                  width="85"
                  style="margin-top: 10px; padding-left: 30px;"
                >
                  <f7-row>
                    <f7-col
                      width="10"
                      class="HoraPrevista"
                    >
                      <span>{{ pedido.HoraInicio }}</span>
                    </f7-col>
                    <f7-col
                      width="5"
                      class="Prioridad"
                    >
                      <span>{{ pedido.Prioridad }}</span>
                    </f7-col>
                    <f7-col
                      width="70"
                      class="titulo-almacen"
                    >
                      <span>{{ `${pedido.Pedido} → ${pedido.NombreCompleto}` }}</span>
                    </f7-col>
                    <f7-col width="5">
                      <div
                        v-if="pedido.Estado === 'INICIADO'"
                        class="div-indicadorNumeroTrabajadoresLineaPedido"
                        @click="AbrirNumeroTrabajadoresLineaPedidoActiva(pedido)"
                      >
                        <img
                          alt="iconTrabajador"
                          align="right"
                          src="@/static/icons/ic_workers_yellow_indicator.svg"
                          class="seleccionable"
                        >
                        <!--
                        <span
                          v-if="numeroTrabajadoresLinea>0"
                          class="span-indicadorNumeroTrabajadores"
                        > {{ ObtenerNumeroTrabajadoresLineaPedidoVentaEnCurso(pedido) }}</span>
                        -->
                        <span
                          v-if="numeroTrabajadoresLinea > 0"
                          class="span-indicadorNumeroTrabajadores"
                        > {{ pedido.NumeroTrabajadoresLineaPedido }}</span>
                      </div>
                    </f7-col>
                    <f7-col width="10">
                      <div
                        v-if="pedido.Estado === 'INICIADO'"
                        class="div-rectanguloEnCurso"
                      >
                        <span>{{ $t('common.inProcessWay').toUpperCase() }} </span>
                      </div>
                      <div
                        v-if="pedido.Estado === 'PAUSADO'"
                        class="div-rectanguloPausado"
                      >
                        <span>{{ $t('common.paused').toUpperCase() }}</span>
                      </div>
                    </f7-col>
                  </f7-row>
                  <f7-row style="margin-top: 10px;">
                    <f7-col width="80">
                      <span class="ProductoPedido">{{ `${pedido.Producto} →` }}</span>
                      <span class="ProductoPedidoGris">{{ pedido.Envase }}</span>
                    </f7-col>
                    <f7-col width="20">
                      <img
                        align="right"
                        alt="iconSetting"
                        src="@/static/icons/ic_options_dark.svg"
                        class="seleccionable"
                        @click="MostrarDetalleLineaPedidoPlanificado(pedido)"
                      >
                    </f7-col>
                  </f7-row>
                  <f7-row class="display-flex align-items-center">
                    <f7-col
                      width="10"
                      class="oval"
                    >
                      <span
                        v-if="pedido.Estado === 'PENDIENTE'"
                        class="btn-oval-azulOscuro-100 seleccionable"
                        @click="IniciarCostesPedido(pedido)"
                      >
                        <img
                          alt="iconPlay"
                          class="img-play"
                          src="@/static/icons/ic_play.svg"
                          width="24px"
                        >
                      </span>
                      <span
                        v-if="pedido.Estado === 'INICIADO'"
                        class="btn-oval-amarillo-100 seleccionable"
                        @click="SolicitudDetenerCostesPedido(pedido)"
                      >
                        <img
                          alt="iconTickOff"
                          src="@/static/icons/ic_check_off.svg"
                          width="40px"
                        >
                      </span>
                      <span
                        v-if="pedido.Estado === 'PAUSADO'"
                        class="btn-oval-grisOscuro-90 seleccionable"
                        @click="ReanudarCostesPedido(pedido)"
                      >
                        <img
                          class="img-pause"
                          alt="iconPause"
                          src="@/static/icons/ic_pause.svg"
                        >
                      </span>
                    </f7-col>
                    <f7-col
                      width="90"
                      class="progresoPedido"
                    >
                      <div
                        v-if="pedido.Rendimiento != null"
                        class="progresoPedidoPrevisto"
                        :style="{ width: `${pedido.Rendimiento.PorcentajeEstimadoCompletado}%` }"
                      />
                      <div
                        v-if="pedido.Rendimiento != null && pedido.PorcentajeRealCompletado !== 0"
                        class="progresoPedidoReal"
                        :class="{
                          Rojo: pedido.Rendimiento.TipoSituacionColor === 'Rojo' ? true : false,
                          Verde: pedido.Rendimiento.TipoSituacionColor === 'Verde' ? true : false,
                          Naranja: pedido.Rendimiento.TipoSituacionColor === 'Naranja' ? true : false,
                        }"
                        :style="{ width: `${pedido.PorcentajeRealCompletado}%` }"
                      />
                      <div
                        v-if="pedido.Rendimiento == null && pedido.PorcentajeRealCompletado !== 0"
                        class="progresoPedidoSinDatosRendimiento Azul"
                        :style="{ width: `${pedido.PorcentajeRealCompletado}%` }"
                      />
                    </f7-col>
                  </f7-row>
                </f7-col>
                <f7-col
                  width="15"
                  style="margin-top: 17px; padding-right: 30px;"
                >
                  <f7-row class="elementoCantidades">
                    <span class="CantidadKilos">{{ pedido.PesoNeto }}</span>
                    <span class="labelCantidad"> {{ $t('common.kilos').toUpperCase() }} </span>
                  </f7-row>
                  <f7-row class="elementoCantidades">
                    <span class="CantidadPalets">{{ `${pedido.CantidadReservada} ${$t('common.of')} ${pedido.CantidadPalet}` }}</span>
                    <span class="labelCantidad"> {{ $t('common.pallets').toUpperCase() }} </span>
                  </f7-row>
                  <f7-row class="elementoCantidades">
                    <span class="CantidadPalets">{{ `${pedido.CantidadEnvaseRealizadoReal} ${$t('common.of')} ${pedido.CantidadEnvase}` }}</span>
                    <span class="labelCantidad"> {{ $t('common.packages').toUpperCase() }} </span>
                  </f7-row>
                </f7-col>
              </f7-row>
            </div>
          </f7-col>
        </f7-row>
      </f7-col>
    </f7-row>

    <!-- Popup DetallePedidoSeleccionadoAbierto -->
    <f7-popup
      class="edicionPedidoPlanificado-popup"
      :opened="popupDetallePedidoSeleccionadoAbierto"
      @popup:closed="popupDetallePedidoSeleccionadoAbierto = false"
    >
      <TheNavbar
        sliding
        :nav-title="$t('production.common.salesOrderDetail')"
        :popup-close-btn-enable="true"
        :style="appTheme"
      />
      <div
        v-if="lineaPedidoEnProduccionSeleccionado != null"
        class="div-frmDetalleLineaPedido"
      >
        <PCDetalleLineaPedidoVenta
          :pedido-seleccionado="lineaPedidoEnProduccionSeleccionado"
          :elementos-mostrar="[
            'DireccionDeEnvio',
            'ObservacionesPedidoVenta',
            'ObservacionesLineaPedidoVenta',
            'ObservacionesPorte',
            'ReferenciaPedidoVenta',
            'Lote',
            'UbicacionPalesProducidos',
            'FechaSalida',
          ]"
        />
      </div>
    </f7-popup>

    <!-- Popup Detalle Trabajadores Linea -->
    <f7-popup
      class="detalleTrabajadoresLinea-popup"
      :opened="popupDetalleTrabajadoresLineaAbierto"
      @popup:closed="popupDetalleTrabajadoresLineaAbierto = false"
    >
      <TheNavbar
        sliding
        :nav-title="$t('TrabajadoresLineaDeProduccion')"
        :popup-close-btn-enable="true"
        :style="appTheme"
      />
      <div>
        <PCLineaProduccionNumeroTrabajadores
          id-componente="trabajadores-linea-produccion"
          :activo="popupDetalleTrabajadoresLineaAbierto"
          :linea-produccion-seleccionada="lineaSeleccionada"
          :habilitar-edicion="usarRepartoDeTrabajadoresLineaProduccionProporcional"
          @confirmar="ObtenerNumeroTrabajadoresLineaProduccion(); popupDetalleTrabajadoresLineaAbierto = false"
          @cancelar="popupDetalleTrabajadoresLineaAbierto = false"
        />
      </div>
    </f7-popup>

    <!-- Popup Detalle Trabajadores por parte de produccion -->
    <f7-popup
      class="detalleTrabajadoresParte-popup"
      :opened="popupDetalleTrabajadoresParteProduccionAbierto"
      @popup:closed="popupDetalleTrabajadoresParteProduccionAbierto = false"
    >
      <TheNavbar
        sliding
        :nav-title="$t('TrabajadoresDelParteDeProduccion')"
        :popup-close-btn-enable="true"
        :style="appTheme"
      />
      <div v-if="lineaPedidoEnProduccionSeleccionado != null">
        <PCParteProduccionNumeroTrabajadores
          id-componente="trabajadores-parte-produccion"
          :linea-produccion-seleccionada="lineaSeleccionada"
          :linea-pedido-venta-seleccionada="lineaPedidoEnProduccionSeleccionado.LineaPedidoVenta"
          :parte-produccion="lineaPedidoEnProduccionSeleccionado.ParteProduccion"
          :activo="popupDetalleTrabajadoresParteProduccionAbierto"
          :habilitar-edicion="!usarRepartoDeTrabajadoresLineaProduccionProporcional"
          @confirmar="ObtenerNumeroTrabajadoresLineaProduccion(); ObtenerNumeroTrabajadoresLineasPedidoVentaActivas(); popupDetalleTrabajadoresParteProduccionAbierto = false"
          @cancelar="popupDetalleTrabajadoresParteProduccionAbierto = false"
        />
      </div>
    </f7-popup>

    <UCConfirmation
      ref="UCConfirmation"
      :cancel="$t('common.pause')"
      :confirm="$t('common.finish')"
    />
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import TheNavbar from '@/components/TheNavbar.vue';
import { sleep } from '@/js/utils/sleep';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { LOGO_HISPATEC } from '@/js/common/constants';
import ConexionTA, {
  callComprobarSiTodosLosPalesYEnvasesDeLaLineaPedidoHanSidoReservadoAlPedido,
  callDetenerCostesPedido,
  callIniciarCostesPedido,
  callObtenerRendimientosEstimadosLineasPedidosActivosDeXLineaProduccion,
  callPausarCostesPedido,
  callReanudarCostesPedido,
} from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import PCDetalleLineaPedidoVenta from '@/components/production/traceability/PCDetalleLineaPedidoVenta.vue';
import PCLineaProduccionNumeroTrabajadores from '@/components/production/productionLinesManagement/PCLineaProduccionNumeroTrabajadores.vue';
import PCParteProduccionNumeroTrabajadores from '@/components/production/productionLinesManagement/PCParteProduccionNumeroTrabajadores.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import { f7 } from 'framework7-vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';

export default {
  name: 'FrmProductionPlanningStatus',
  components: {
    TheNavbar,
    UCSearchEntityERP,
    PCDetalleLineaPedidoVenta,
    PCSideNavbar,
    PCLineaProduccionNumeroTrabajadores,
    PCParteProduccionNumeroTrabajadores,
    UCPreload,
    UCConfirmation,
  },

  data() {
    return {
      lineaSeleccionada: null, // Mantiene la linea seleccionada.
      listadoPedidosPlanificados: null, // Mantiene los pedidos planificados.
      mostrarPrecarga: false,
      lineaSeleccionadaAlIniciarFormulario: null,
      lineaPedidoEnProduccionSeleccionado: null,
      popupDetallePedidoSeleccionadoAbierto: false,
      lstTrabajadoresLineaProduccion: null,
      numeroTrabajadoresLinea: 0,
      numeroLineasPedidoEnCurso: 0, // Mantiene el contador de pedidos que estan en curso en un determinado momento.

      /**
       * Mantiene el timer que realiza las actualizaciones automáticas de los rendimientos.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomaticoRendimientos: null,

      intervaloActualizacionAutomaticaRendimientos: 60, // Intervalo minutos en el que se refrescan los rendimientos
      popupDetalleTrabajadoresLineaAbierto: false,
      popupDetalleTrabajadoresParteProduccionAbierto: false,
      lineasProduccion: null,
      LOGO_HISPATEC,
      usarRepartoDeTrabajadoresLineaProduccionProporcional: useParamRef('NumeroTrabajadoresManualLineasProduccionLineaPedido'),
      logoApp: useSettingRef('App.Logo'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
      'getLineasProduccion',
    ]),

    ...mapWritableState(useTraceabilityStore, ['lineaDeProduccionSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  mounted() {
    this.IncializarFrm();
  },

  unmounted() {
    this.EliminarIntervaloActualizacionRendimiento();
  },

  methods: {
    IncializarFrm() {
      Log(this, this.IncializarFrm.name);

      this.lineaSeleccionadaAlIniciarFormulario = this.lineaDeProduccionSeleccionada;
      this.lineaSeleccionadaAlIniciarFormulario ??= this.lineasDeProduccionDelUsuarioDefinidaEnERP;
      this.lineasProduccion = this.getLineasProduccion;
      // this.puntosDePaletizado = this.lineasProduccion.PuntosDePaletizado;
    },

    LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);
      if (lineaSeleccionada != null) {
        this.lineaDeProduccionSeleccionada = lineaSeleccionada;
      }
      this.RestablecerValoresFrm();
      this.lineaSeleccionada = lineaSeleccionada;
      if (lineaSeleccionada == null) {
        return;
      }
      this.ObtenerPedidosPlanificadosLinea();
    },

    RestablecerValoresFrm() {
      Log(this, this.RestablecerValoresFrm.name);
      this.listadoPedidosPlanificados = null;
      this.lineaPedidoEnProduccionSeleccionado = null;
      this.lstTrabajadoresLineaProduccion = null;
      this.numeroTrabajadoresLinea = 0;
      this.numeroLineasPedidoEnCurso = 0;
      this.EliminarIntervaloActualizacionRendimiento();
    },

    LineaPedidoPlanificadoSeleccionado(lineaPedidoEnProduccion) {
      Log(this, this.LineaPedidoPlanificadoSeleccionado.name);
      // Mapeamos los datos con la estructura necesaria para que funcionen el resto de componentes
      this.lineaPedidoEnProduccionSeleccionado = {
        ParteProduccion: {
          Id: lineaPedidoEnProduccion.Id_ParteProduccion,
          Serie: lineaPedidoEnProduccion.SerieParteProduccion,
          Numero: lineaPedidoEnProduccion.NumeroParteProduccion,
          ParteProduccionReal: {
            Id: lineaPedidoEnProduccion.IdParteProduccionReal,
          },
        },
        LineaPedidoVenta: {
          Id: lineaPedidoEnProduccion.IdLineaPedidoVenta,
          PedidoVenta: {
            Id: lineaPedidoEnProduccion.Id_PedidoVenta,
          },
        },
        DireccionDeEnvio: lineaPedidoEnProduccion.DireccionEnvio,
        PuntoPaletizado: {
          UbicacionPalesProducidos: null,
        },
        Lote: {
          Codigo: lineaPedidoEnProduccion.CodigoLote ? lineaPedidoEnProduccion.CodigoLote : '',
        },
        ReferenciaPedidoVenta: lineaPedidoEnProduccion.Referencia,
        ObservacionesPedidoVenta: {
          Texto: lineaPedidoEnProduccion.ObservacionesCabecera,
        },
        ObservacionesLineaPedidoVenta: {
          Texto: lineaPedidoEnProduccion.ObservacionesLinea,
        },
      };
    },

    MostrarDetalleLineaPedidoPlanificado(lineaPedidoEnProduccion) {
      Log(this, this.MostrarDetalleLineaPedidoPlanificado.name);
      this.LineaPedidoPlanificadoSeleccionado(lineaPedidoEnProduccion);
      this.popupDetallePedidoSeleccionadoAbierto = true;
    },

    AbrirFormularioDePedidosCompletos() {
      Log(this, this.AbrirFormularioDePedidosCompletos.name);
      // if (!comprobarAutorizacionDeAccesoDelUsuario('EP', true)) return;
      f7.views.main.router.navigate('/production/productionLines/productionLinesManagement/FrmProductionPlanningStatusComplete', {
        reloadCurrent: true,
        reloadPrevious: true,
        pushState: false,
      });
      window.screen.orientation.lock('landscape');
    },

    ObtenerPedidosPlanificadosLinea() {
      Log(this, this.ObtenerPedidosPlanificadosLinea.name);
      const self = this;
      self.mostrarPrecarga = true;
      this.EliminarIntervaloActualizacionRendimiento();
      this.Conexion_ObtenerPedidosPlanificadosLinea(this.lineaSeleccionada.Id).then((result) => {
        // Procesamos la respuesta para con posterioridad añadirle el rendimiento correspondiente.
        const tempPedidosPlanificados = JSON.parse(result.Mensaje);
        tempPedidosPlanificados.forEach((element) => {
          element.Rendimiento = null;
        });

        self.listadoPedidosPlanificados = tempPedidosPlanificados;
        self.ObtenerNumeroTrabajadoresLineaProduccion();
        self.CalcularNumeroLineasPedidoEnCurso();
        self.ObtenerNumeroTrabajadoresLineasPedidoVentaActivas();
        self.ObtenerRendimientosEstimados();
        self.ProgramarIntervaloActualizacionRendimiento();
      })
        .catch((result) => {
          self.listadoPedidosPlanificados = null;
          HiNotification.Toast(result.Mensaje);
        })
        .finally(() => {
          self.mostrarPrecarga = false;
        });
    },

    async ObtenerNumeroTrabajadoresLineasPedidoVentaActivas() {
      Log(this, this.ObtenerNumeroTrabajadoresLineasPedidoVentaActivas.name);
      if (this.usarRepartoDeTrabajadoresLineaProduccionProporcional) {
        this.listadoPedidosPlanificados.forEach((lp) => {
          if (lp.Estado === 'INICIADO') {
            lp.NumeroTrabajadoresLineaPedido = Math.floor(this.numeroTrabajadoresLinea / this.numeroLineasPedidoEnCurso);
          } else {
            lp.NumeroTrabajadoresLineaPedido = 0;
          }
        });
      } else {
        this.listadoPedidosPlanificados.forEach(async (lp) => {
          if (lp.Estado === 'INICIADO') {
            const tempNumeroTrabajadoiresLineaPedido = await this.ObtenerNumeroTrabajadoresLineaPedidoVentaEnCurso(lp);
            lp.NumeroTrabajadoresLineaPedido = tempNumeroTrabajadoiresLineaPedido;
          } else {
            lp.NumeroTrabajadoresLineaPedido = 0;
          }
        });
      }
    },

    ObtenerRendimientosEstimados() {
      Log(this, this.ObtenerRendimientosEstimados.name);
      const self = this;
      this.Conexion_ObtenerRendimientosEstimadosLineasPedidosActivosDeXLineaProduccion(this.lineaSeleccionada.Id).then((result) => {
        const tempRendimientos = result;
        // Añadimos cada rendimiento a su registro de tempPedidosPlanificados
        self.listadoPedidosPlanificados.forEach((element) => {
          element.Rendimiento = tempRendimientos.find((r) => r.LineaPedidoVenta.Id === element.IdLineaPedidoVenta);
        });
      })
        .catch((result) => {
          LogError(`FrmProductionPlanningStatus->ObtenerRendimientosEstimados--> Los rendimientos no han sido obtenidos ${result}`);
        });
    },

    CalcularNumeroLineasPedidoEnCurso() {
      Log(this, this.CalcularNumeroLineasPedidoEnCurso.name);
      this.numeroLineasPedidoEnCurso = this.listadoPedidosPlanificados.filter((lp) => lp.Estado === 'INICIADO').length;
    },

    ObtenerNumeroTrabajadoresLineaProduccion() {
      Log(this, this.ObtenerNumeroTrabajadoresLineaProduccion.name);
      const self = this;
      const momentoConsulta = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      // OPCIÓN 1 - Lineas de Producción que obtienen el número de trabajadores de TrabajadorElementoProducción.
      if (!this.lineaSeleccionada.UsoNumTrabajadoresManual) {
        this.Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(this.lineaSeleccionada.Id, momentoConsulta)
          .then((result) => {
            self.lstTrabajadoresLineaProduccion = JSON.parse(result.Mensaje);
            self.numeroTrabajadoresLinea = self.lstTrabajadoresLineaProduccion.length;
          })
          .catch((result) => {
            HiNotification.Toast(result.Mensaje);
          });
      } else {
        // OPCIÓN 2 - Lineas de Producción que permiten introducir el número de trabajadores de forma manual.
        this.Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(this.lineaSeleccionada.Id, momentoConsulta)
          .then((result) => {
            self.numeroTrabajadoresLinea = result.Mensaje;
          })
          .catch((result) => {
            HiNotification.Toast(result.Mensaje);
          });
      }
    },

    /** Fuerza el refresco del DOM de Vue cuando no se detectan los cambios en propiedades */
    ForzarReactividadListaPedidosPlanificados() {
      Log(this, this.ForzarReactividadListaPedidosPlanificados.name);
      const tempListadoPedidosPlanificados = this.listadoPedidosPlanificados;
      this.listadoPedidosPlanificados = null;
      sleep(1).then(() => {
        this.listadoPedidosPlanificados = tempListadoPedidosPlanificados;
      });
    },

    IniciarCostesPedido(lineaPedidoEnProduccion) {
      Log(this, this.IniciarCostesPedido.name);
      const self = this;
      PreloaderGH(true, true, 'Iniciando pedido...');
      this.Conexion_IniciarCostes(lineaPedidoEnProduccion.IdParteProduccionReal, this.lineaSeleccionada.Id).then(() => {
        HiNotification.Toast('Se han iniciado los costes del pedido');
      })
        .catch((result) => {
          HiNotification.Toast(result.Mensaje);
        })
        .finally(() => {
          PreloaderGH(false);
          self.ObtenerPedidosPlanificadosLinea();
        });
    },

    SolicitudDetenerCostesPedido(lineaPedidoEnProduccion) {
      Log(this, this.SolicitudDetenerCostesPedido.name);
      this.LineaPedidoPlanificadoSeleccionado(lineaPedidoEnProduccion);
      // this.lineaPedidoEnProduccionSeleccionado = lineaPedidoEnProduccion;
      const self = this;
      PreloaderGH(true, true, 'Consultando reservas....');
      this.Conexion_ComprobarSiTodosLosPalesYEnvasesDeLaLineaPedidoHanSidoReservadoAlPedido(this.lineaPedidoEnProduccionSeleccionado.ParteProduccion.ParteProduccionReal.Id, this.lineaPedidoEnProduccionSeleccionado.LineaPedidoVenta.Id).then((result) => {
        PreloaderGH(false);
        const envasesCompletados = JSON.parse(result.Mensaje);
        if (envasesCompletados) {
          self.DetenerCostesPedido();
        } else {
          this.$refs.UCConfirmation.create(
            this.$t('PalesNoCompletados').toUpperCase(),
            this.$t('PaleNoCompletadoMensajeFinalizacion'),
            () => {
              self.DetenerCostesPedido();
            },
            () => {
              self.PausarCostesPedido();
            },
          );
          this.$refs.UCConfirmation.show();
        }
      })
        .catch((result) => {
          self.listadoPedidosPlanificados = null;
          HiNotification.Toast(result.Mensaje);
        });

      //
    },

    DetenerCostesPedido() {
      Log(this, this.DetenerCostesPedido.name);
      const self = this;
      PreloaderGH(true, true, 'Finalizando costes del pedido...');
      this.Conexion_DetenerCostesPedido(this.lineaPedidoEnProduccionSeleccionado.ParteProduccion.ParteProduccionReal.Id, this.lineaSeleccionada.Id).then((result) => {
        PreloaderGH(false);
        if (result.Valor) {
          HiNotification.Toast('Se han finalizado los costes del pedido.');
        } else {
          HiNotification.Toast(result.Mensaje);
        }
      })
        .catch((result) => {
          PreloaderGH(false);
          HiNotification.Toast(result.Mensaje);
        })
        .finally(() => {
          PreloaderGH(false);
          self.ObtenerPedidosPlanificadosLinea();
        });
    },

    PausarCostesPedido() {
      Log(this, this.PausarCostesPedido.name);
      const self = this;
      PreloaderGH(true, true, 'Pausando costes del pedido...');
      this.Conexion_PausarCostesPedido(this.lineaPedidoEnProduccionSeleccionado.ParteProduccion.ParteProduccionReal.Id, this.lineaSeleccionada.Id).then((result) => {
        if (result.Valor) {
          HiNotification.Toast('Se han pausado costes del pedido.');
        } else {
          HiNotification.Toast(result.Mensaje);
        }
      })
        .catch((result) => {
          HiNotification.Toast(result.Mensaje);
        })
        .finally(() => {
          PreloaderGH(false);
          self.ObtenerPedidosPlanificadosLinea();
        });
    },

    ReanudarCostesPedido(lineaPedidoEnProduccion) {
      Log(this, this.ReanudarCostesPedido.name);
      this.LineaPedidoPlanificadoSeleccionado(lineaPedidoEnProduccion);
      // this.lineaPedidoEnProduccionSeleccionado = lineaPedidoEnProduccion;
      const self = this;
      PreloaderGH(true, true, 'Reanudando parte produccion...');
      this.Conexion_ReanudarCostesPedido(this.lineaPedidoEnProduccionSeleccionado.ParteProduccion.ParteProduccionReal.Id, this.lineaSeleccionada.Id).then((result) => {
        if (result.Valor) {
          HiNotification.Toast('Parte producción reanudado');
        } else {
          HiNotification.Toast(result.Mensaje);
        }
      })
        .catch((result) => {
          HiNotification.Toast(result.Mensaje);
        })
        .finally(() => {
          PreloaderGH(false);
          self.ObtenerPedidosPlanificadosLinea();
        });
    },

    ProgramarIntervaloActualizacionRendimiento() {
      Log(this, this.ProgramarIntervaloActualizacionRendimiento.name);
      const self = this;
      this.actualizadorAutomaticoRendimientos = setInterval(() => {
        self.ObtenerRendimientosEstimados();
        Log(this, 'Actualización de Rendimientos Solicitada');
      }, this.intervaloActualizacionAutomaticaRendimientos * 1000);
    },

    EliminarIntervaloActualizacionRendimiento() {
      Log(this, this.EliminarIntervaloActualizacionRendimiento.name);
      if (this.actualizadorAutomaticoRendimientos) {
        clearInterval(this.actualizadorAutomaticoRendimientos);
      }
    },

    ActualizarPedidosPlanificadosLineaProduccion() {
      Log(this, this.ActualizarPedidosPlanificadosLineaProduccion.name);
      if (this.lineaSeleccionada != null) {
        this.ObtenerPedidosPlanificadosLinea();
        this.numeroTrabajadoresLinea = 0;
      } else {
        HiNotification.Toast('Selecciona una linea de producción.');
      }
    },

    IndicarNumeroTrabajadorLineaManual() {
      Log(this, this.IndicarNumeroTrabajadorLineaManual.name);
      // Solo podemos cambiar el valor si la linea permite introducir el número de trabajadores de forma manual.
      if (this.lineaSeleccionada !== null && this.lineaSeleccionada.UsoNumTrabajadoresManual) {
        this.popupDetalleTrabajadoresLineaAbierto = true;
      }
    },

    async ObtenerNumeroTrabajadoresLineaPedidoVentaEnCurso(pLineaPedidoVentaProduccion) {
      Log(this, this.ObtenerNumeroTrabajadoresLineaPedidoVentaEnCurso.name);
      return this.Conexion_ObtenerNumeroDeTrabajadoresLineaPedidoVentaProduccion(this.lineaSeleccionada.Id, pLineaPedidoVentaProduccion.IdLineaPedidoVenta, pLineaPedidoVentaProduccion.Id_ParteProduccion, SoporteFechaYHora.ObtenerFechaYHoraActual());
    },

    AbrirNumeroTrabajadoresLineaPedidoActiva(pLineaPedidoActiva) {
      Log(this, this.AbrirNumeroTrabajadoresLineaPedidoActiva.name);
      this.LineaPedidoPlanificadoSeleccionado(pLineaPedidoActiva);
      this.popupDetalleTrabajadoresParteProduccionAbierto = true;
    },

    Conexion_ObtenerPedidosPlanificadosLinea(idLineaProduccion) {
      Log(this, this.Conexion_ObtenerPedidosPlanificadosLinea.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerPedidosPlanificadosLineaProduccion(idLineaProduccion)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento) {
      Log(this, this.Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento) {
      Log(this, this.Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_IniciarCostes(idParteProduccionReal, idLineaProduccion) {
      Log(this, this.Conexion_IniciarCostes.name);
      return new Promise((resolve, reject) => {
        callIniciarCostesPedido(idParteProduccionReal, idLineaProduccion)
          .then((result) => {
            if (result.Valor) {
              resolve(result.Mensaje);
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            LogError(`FrmProductionPlanningStatus->Conexion_IniciarCostes${error}`);
            reject(error);
          });
      });
    },

    Conexion_DetenerCostesPedido(idParteProduccionReal, idLineaProduccion) {
      Log(this, this.Conexion_DetenerCostesPedido.name);
      return new Promise((resolve, reject) => {
        callDetenerCostesPedido(idParteProduccionReal, idLineaProduccion)
          .then((result) => {
            if (result) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            LogError(`FrmProductionPlanningStatus->Conexion_DetenerCostesPedido${error}`);
            reject(error);
            // PreloaderGH(false);
            // HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          });
      });
    },

    Conexion_PausarCostesPedido(idParteProduccionReal, idLineaProduccion) {
      Log(this, this.Conexion_PausarCostesPedido.name);
      return new Promise((resolve, reject) => {
        callPausarCostesPedido(idParteProduccionReal, idLineaProduccion)
          .then((result) => {
            if (result) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            LogError(`FrmProductionPlanningStatus->Conexion_PausarCostesPedido${error}`);
            reject(error);
          });
      });
    },

    Conexion_ComprobarSiTodosLosPalesYEnvasesDeLaLineaPedidoHanSidoReservadoAlPedido(idPartesProduccionReal, idLineaPedidoVenta) {
      Log(this, this.Conexion_ComprobarSiTodosLosPalesYEnvasesDeLaLineaPedidoHanSidoReservadoAlPedido.name);
      return new Promise((resolve, reject) => {
        callComprobarSiTodosLosPalesYEnvasesDeLaLineaPedidoHanSidoReservadoAlPedido(idPartesProduccionReal, idLineaPedidoVenta)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ReanudarCostesPedido(idParteProduccionReal, idLineaPedidoVenta) {
      Log(this, this.Conexion_ReanudarCostesPedido.name);
      return new Promise((resolve, reject) => {
        callReanudarCostesPedido(idParteProduccionReal, idLineaPedidoVenta)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerRendimientosEstimadosLineasPedidosActivosDeXLineaProduccion(idLineaProduccion) {
      Log(this, this.Conexion_ObtenerRendimientosEstimadosLineasPedidosActivosDeXLineaProduccion.name);
      return new Promise((resolve, reject) => {
        callObtenerRendimientosEstimadosLineasPedidosActivosDeXLineaProduccion({ productionLineId: idLineaProduccion })
          .then((result) => {
            if (result.Valor) {
              resolve(JSON.parse((result.Mensaje)));
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerNumeroDeTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento) {
      Log(this, this.Conexion_ObtenerNumeroDeTrabajadoresLineaPedidoVentaProduccion.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerNumeroDeTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result.Mensaje);
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  // TODO: Remove when migrated to new styles
  --f7-grid-row-gap: 0;
  //

  background-color: #f7f7f7;
  --information-bar-padding-bottom: 0;
}

.titulo-almacen {
  color: var(--his-steel-blue);
  font-size: 24px;
  font-weight: 500;
  line-height: 29px;
  text-align: left;
}

.titulo-almacen-centro {
  color: var(--his-plum-shadow);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
  max-width: 80px;
  height: 100vh;
  float: left;
}

.selector-lineaproduccion {
  background-color: rgb(9 30 66 / 4%);
  border: 1px solid rgb(9 30 66 / 25%);
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgb(9 30 66 / 4%);
  height: 58px;
}

.selector-lineaproduccion-textolinea {
  color: var(--his-steel-blue);
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  vertical-align: middle;
  padding-top: 15px;
  padding-left: 16px;
}

.selector-lineaproduccion-navegacion {
  background-color: var(--his-steel-blue);
  border-radius: 8px;
  width: 58px;
  height: 58px;
  max-width: 58px;
  max-height: 58px;
}

.ElementoPedido {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
  height: 225px;
  margin-right: 30px;
  margin-top: 15px;
  min-height: 200px;
}

.HoraPrevista {
  display: flex;
  justify-content: center;
  background-color: rgb(122 134 154 / 20%);
  border-radius: 14px;
  max-width: 76px;
  min-width: 76px;
  height: 28px;
  text-align: center;
}

.HoraPrevista span,
.Prioridad span {
  display: flex;
  align-items: center;
  color: var(--his-steel-blue);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 17px;
  text-align: center;
}

.Prioridad {
  display: flex;
  justify-content: center;
  background-color: rgb(122 134 154 / 20%);
  border-radius: 14px;
  max-width: 30px;
  min-width: 30px;
  height: 28px;
  text-align: center;
}

.ProductoPedido {
  color: var(--his-steel-blue);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 24px;
  text-align: left;
}

.ProductoPedidoGris {
  color: var(--his-kiwi-pulp);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 24px;
  text-align: left;
}

.progresoPedido {
  /* margin-top: 10px; */
  background-color: #f4f5f7;
  border-radius: 100px;
  height: 60px;
}

.progresoPedidoPrevisto {
  background-color: var(--his-kiwi-pulp);
  opacity: 0.3208372201492538;
  border-radius: 100px;
  width: 366px;
  height: 80px;
  min-width: 80px;
}

.progresoPedidoReal {
  position: relative;
  background-color: var(--his-mandarina);
  border-radius: 100px;
  opacity: 1;
  height: 80px;
  top: -80px;
}

.progresoPedidoSinDatosRendimiento {
  position: relative;
  background-color: var(--his-mandarina);
  border-radius: 100px;
  opacity: 1;
  height: 60px;
}

.progresoPedidoRealVerde {
  background-color: var(--his-greenlight);
  min-width: 80px;
}

.oval {
  max-width: 88px;
  min-width: 88px;
}

.CantidadKilos {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 34px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 41px;
  text-align: right;
}

.labelCantidad {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 17px;
  opacity: 0.5017206101190477;
  text-align: right;
}

.CantidadPalets {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 22px;
  text-align: right;
}

.elementoCantidades {
  margin-bottom: 15px;
}

.span-tituloColumnas {
  color: var(--his-plum-shadow);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-contenido {
  margin-left: 100px;
  margin-right: 10px;
}

.div-rectanguloEnCurso {
  background-color: var(--his-mandarina);
  border-radius: 3px;
  width: 78px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
}

.div-rectanguloEnCurso span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-rectanguloPausado {
  background-color: #c4c4c4;
  border-radius: 3px;
  width: 78px;
  height: 19px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  padding-bottom: 5px;
}

.div-rectanguloPausado span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-logoHispatecDerecha {
  max-width: 250px;
  margin-top: 18px;
  border-left: 1px solid rgb(151 151 151 / 30%);
  text-align: end;
  padding-right: 15px;

  /* height: 79px; */
}

.div-btnCambioPedidosPendientesFinalizados {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  /* float: right; */
  margin-right: 30px;
}

.div-btnCambioPedidosPendientesFinalizados span {
  color: var(--his-kiwi-pulp);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: left;
}

.row-cabeceraOpcionesFrm {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.img-play {
  margin-left: 5px;
}

.img-pause {
  width: 75px;
  margin-right: 2px;
}

.Verde {
  background-color: var(--his-greenlight);
  min-width: 80px;
}

.Naranja {
  background-color: #ff9333;
  min-width: 80px;
}

.Rojo {
  background-color: #f33;
  min-width: 80px;
}

.Azul {
  background-color: var(--his-steel-blue);
  min-width: 80px;
}

.span-indicadorNumeroTrabajadores {
  position: absolute;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  left: 30px;
  top: 22px;
}

.div-indicadorNumeroTrabajadoresLineaPedido {
  position: relative;
  width: 50px;
  height: 50px;
}

.div-indicadorNumeroTrabajadoresLineaProduccion {
  position: relative;
  width: 50px;
  height: 50px;
  margin-right: 20px;
  margin-top: 6px;
}

.btn-actualizarPlanificadosLinea {
  margin-top: 18px;
  margin-right: 20px;
}

.img-logoHispatec {
  padding-left: 45px;
}

.temp-padding-top {
  padding-top: 20px;
}
</style>
